import { render, staticRenderFns } from "./DashInventoryClientContact.vue?vue&type=template&id=200f0d8c&scoped=true&"
import script from "./DashInventoryClientContact.vue?vue&type=script&lang=js&"
export * from "./DashInventoryClientContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f0d8c",
  null
  
)

export default component.exports